export enum Roles {
  Read = "Read",
  Write = "Write",
  ReadWrite = "ReadWrite",
  Manager = "Manager",
  ReadAll = "Read.All",
  ReadWriteAll = "ReadWrite.All",
  NotPermission = "",
  UserRead = "User.Read",
  UserReadWrite = "User.ReadWrite",
  ResourceRead = "Resource.Read",
  ResourceReadWrite = "Resource.ReadWrite",
  GroupRead = "Group.Read",
  GroupReadWrite = "Group.ReadWrite",
  ApplicationRead = "Application.Read",
  ApplicationReadWrite = "Application.ReadWrite",
  SyncRead = "Sync.Read",
  SyncReadWrite = "Sync.ReadWrite",
  TenantRead = "Tenant.Read",
  TenantReadWrite = "Tenant.ReadWrite",
}